// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const DoubleChevronDown: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
                <path d="M11.971 20.482a1.496 1.496 0 0 1-1.06-.433l-5.972-5.972a1.5 1.5 0 0 1 2.12-2.12l4.912 4.941 4.927-4.747a1.493 1.493 0 1 1 2.06 2.149l-5.972 5.763a1.493 1.493 0 0 1-1.015.419z" />
                <path d="M11.971 12.482a1.496 1.496 0 0 1-1.06-.433L4.939 6.077a1.5 1.5 0 0 1 2.12-2.12l4.912 4.941 4.927-4.747a1.493 1.493 0 1 1 2.06 2.149l-5.972 5.763a1.493 1.493 0 0 1-1.015.419z" />
            </g>
        </svg>
    );
};

export const DoubleChevronDownOffset: IconOffset = {
    vertical: 14,
    horizontal: 19,
};

export default React.memo(DoubleChevronDown);
